Vendd.Scripts.load(function () {
 
    if ($('.x-off-canvas-menu').length <= 0)
        return;

    if (isTouch()) {
        $(window).resize(function () {
            attachToCanvasMenu();
        });
    }

    var isMoved = false;

    if ($(window).outerWidth() < 1200) {
        if (isTouch()) {
            if ($('.x-currency-selector').length > 0)
                $('.x-currency-selector').detach().prependTo('.js-canvas-menu').show();
            $('.x-call-me-back-widget').detach().prependTo('.js-canvas-menu').show();
            $('.x-shortcut').detach().appendTo('.js-canvas-menu .bottom-menu').show();
            $('.js-main-menu').detach().prependTo('.js-canvas-menu').show();
            $('.js-canvas-menu .bottom-menu li.move-mobile-1').detach().prependTo('.off-canvas-menu .bottom-container ul').show();
            $('.js-canvas-menu .bottom-menu li.move-mobile-2').detach().prependTo('.off-canvas-menu .bottom-container ul').show();
            $('.header-region .x-language-selector').detach().prependTo('.js-canvas-menu').show();
            $('.header-region .x-wishlist-widget').detach().prependTo('.off-canvas-menu .bottom-container').show();

            isMoved = true;
        }
    }

    function attachToCanvasMenu() {

        if ($(window).outerWidth() < 1200) {
            if (!isMoved) {
                if ($('.x-currency-selector').length > 0)
                    $('.x-currency-selector').detach().prependTo('.js-canvas-menu').show();
                $('.x-call-me-back-widget').detach().prependTo('.js-canvas-menu').show();
                $('.x-shortcut').detach().appendTo('.js-canvas-menu .bottom-menu').show();
                $('.js-main-menu').detach().prependTo('.js-canvas-menu').show();
                $('.header-region .x-language-selector').detach().prependTo('.js-canvas-menu').show();
                $('.header-region .x-wishlist-widget').detach().prependTo('.off-canvas-menu .bottom-container').show();
                $('.js-canvas-menu .bottom-menu li.move-mobile-1').detach().prependTo('.off-canvas-menu .bottom-container ul').show();
                $('.js-canvas-menu .bottom-menu li.move-mobile-2').detach().prependTo('.off-canvas-menu .bottom-container ul').show();

                isMoved = true;
            }
        } else {
            if (isMoved) {
                $('.js-main-menu').detach().insertAfter('.x-sitelogo');
                $('.off-canvas-menu .x-language-selector').detach().insertAfter('.x-menu.main-menu');
                $('.off-canvas-menu .x-shortcut').detach().insertAfter('.x-menu.main-menu').css('display', '');
                if ($('.x-currency-selector').length > 0)
                    $('.x-currency-selector').detach().insertAfter('.x-menu.main-menu');
                $('.x-call-me-back-widget').detach().insertAfter('.x-menu.main-menu');
                $('.off-canvas-menu .x-wishlist-widget').detach().insertAfter('.x-productcompare-widget');

                isMoved = false;
            }
        }
    }

});
